import { render, staticRenderFns } from "./NewAuthLayout.vue?vue&type=template&id=45de2810"
import script from "./NewAuthLayout.vue?vue&type=script&lang=js"
export * from "./NewAuthLayout.vue?vue&type=script&lang=js"
import style0 from "./NewAuthLayout.vue?vue&type=style&index=0&id=45de2810&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports